var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"pa-6 text-caption",attrs:{"width":"100px"}},[_vm._v("Copyright © 2021-present Hamochi Sdn Bhd. All Rights Reserved.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }